module.exports = __webpack_public_path__ + "img/protocol.e6a6d877.png";